export default __webpack_public_path__ + "static/media/greenSimpleLogo.30c65683.svg";